export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const LOGOUT_USER = "LOGOUT_USER";

export const PENDIENTE_LOADING = "PENDIENTE_LOADING";
export const PENDIENTE_SUCCESS = "PENDIENTE_SUCCESS";
export const PENDIENTE_ERROR = "PENDIENTE_ERROR";
export const CLEAR_PENDIENTE_DATA = "CLEAR_PENDIENTE_DATA";
export const POST_PENDIENTE_LOADING = "POST_PENDIENTE_LOADING";
export const POST_PENDIENTE_SUCCESS = "POST_PENDIENTE_SUCCESS";
export const POST_PENDIENTE_ERROR = "POST_PENDIENTE_ERROR";


export const HISTORICO_LOADING = "HISTORICO_LOADING";
export const HISTORICO_SUCCESS = "HISTORICO_SUCCESS";
export const HISTORICO_ERROR = "HISTORICO_ERROR";
export const CLEAR_HISTORICO_DATA = "CLEAR_HISTORICO_DATA";
